// 自己説明「選択式回答」の候補語彙。
// 誤り定義の正本は research/デッサン誤り一覧表_V2.xlsx。
//
// ▼方式の根拠（2026-09-28週例で変更）▼
// 旧：EBSの誤り可視化モデルに基づく4要件（①誤ったデッサン②誤った3次元モデル③正しい3次元モデル
//     ④正しいデッサン）を説明に含ませる。
// 新：**カテゴリスキーマ（＝「皿は丸い」といった既存知識）と、ガイドで誤りが解消される過程を
//     紐づけて、誤りの理由を説明させる**。EBSの誤り可視化モデルに基づく説明手法は採らない。
// ▲
//
// ▼一人称を使わない（2026-10-02変更・重要）▼
// 旧文型の書き出しは「わたしは〔knowledge〕と思っていたので…」という一人称だったが、
//   (1) 演習で指摘するのは**他者のデッサンの誤り**なので「わたしは」と書くのは不自然、
//   (2) その既存知識を**持っている学習者と持っていない学習者がいる**ため、自分の思い込みとして
//       断定させるのは測定として不適切、
// の2点で廃止した。新文型は**3次元モデルで顕在化したおかしさを観察し、その誤りをカテゴリスキーマに
// 帰属させて提示する**記述文（主語を立てない）にしてある。これに伴い angle（顕在化視点）と
// state（そこで見えるおかしさ）の2スロットを復活させている。
// ▲
//
// ▼「正しいモチーフの見え方」（旧 seen）は置かない（2026-10-03変更・重要）▼
// 09-28版は①既存知識②知識から導かれる形③正しいモチーフの見え方④直し方の4スロットだったが、
// **③を廃止して5スロット（angle/state/drawn/knowledge/fix）にした**。理由：
//   (1) 形状変更では③と④がほぼ同義（「皿は楕円に見える」↔「楕円のように横長に」）で、
//       同じ理解を二度測るだけになる
//   (2) ③で④を根拠づけると「モチーフを見たから直せる」になり、**ガイドで誤りが解消される過程と
//       紐づける**という方式の根拠から外れる。④の根拠は「形を変えると3Dモデルのおかしさが消える」／
//       「視点を動かすとおかしな箇所がモチーフと同じに見えた」＝**ガイドの結果**に置く
// ③が担っていた「既存知識由来の形と実際の見え方を区別できたか」の測定は、**fix の誤答に
// 対になる語（＝誤って描いた方向）を入れること**で引き継いでいる（下の「選択肢の作り方」参照）。
// ▲
//
// ▼スロット定義（増減する場合はSelfExpSelect.jsのSENTENCE_LINES_BY_PHASEと合わせて編集）▼
//   angle     = 誤りが顕在化される視点。**正本は cameraPositions.js の showHintDescriptions**
//               （PartSelectのヒント・GazeControlの「おかしさが分かる視点」で学習者が実際に体験する
//               視点）。★「いつもの正面」は原理的に顕在化視点になりえないので選択肢に入れない★
//               （いつもの視点では描いたとおりに見えてしまうから顕在化しない）。
//               文型上「3Dモデルを〔angle〕見てみると」に続くので「横から」の語形で書く
//   state     = angle から見たときのおかしさ＝物理的にあり得ない配置・あり得ない見え
//               （典拠は誤り一覧表「学習者が感じる矛盾」列）。文型上そこで文が切れるので言い切りで書く。
//               ★丸皿・グラスの相互貫入は「重なって見える」ではなく**「〜が〜にめり込んで見える」**と書く
//                 （2026-10-04変更：3次元モデルは面どうしが突き抜けており、「重なる」では
//                 あり得なさが伝わらないため）。**主語は誤っている側**（＝赤く示す部品）にそろえ、
//                 誤答には逆向き（相手がめり込む）を混ぜて、どちらが誤りかを見分けられたか測る★
//               ★めり込みは**実際に3Dモデルで見えるものだけ**を書く（2026-10-09変更）。
//                 model3 は食い込みが約3.5mmで真上からは隠れるため「飲み口がつぶれて見える」
//                 （幅だけ太くした結果のあり得ない形）に、model8 はふちを高くしてもグラスに届かず
//                 めり込みが生じていなかったため、底も下げる形（上下両方向）に直して「皿の底がグラスの底より下に
//                 沈みこんで見える」（横から）にした★
//   knowledge = ①学習者が持つと仮定されるカテゴリスキーマ＝既存知識。**正本は誤り一覧表の
//               「既存知識」列**（例 model1＝「皿は丸い」、cube_model5＝「立方体の上面は正方形である」）。
//               文型上「〔knowledge〕という知識にとらわれた誤り」に続くので言い切りの文で書く
//   drawn     = ②その既存知識から導かれる形＝デッサンでどう描かれているか（2次元の記述）。
//               文型上「〔drawn〕点にあり」に続くので**「〜描いている」の形**で書く
//               ★drawn と shape_fix は**紙の上（いつもの視点の画面）での描き方**で書き、誤りの3Dモデルが
//                 どう歪んでいるか（3次元の形）で書かない（2026-10-16変更）。誤りの3Dモデルは「いつもの視点から
//                 見るとデッサンどおりに見える形」なので、遠近法に関わる誤り（立方体）では3次元の形と紙の上の
//                 描き方が食い違う。例 cube_model1＝3Dモデルは奥ほど幅が広がるが、デッサンでは上面の左右の辺が
//                 ほぼ平行に描かれている（正しくは奥ほど狭まる）。旧版は3次元の形で書いていたため、
//                 shape_fix の正解「平行に」が既存知識そのものになっていた★
//   shape_fix = ④あるべきデッサン＝形状変更演習でどう描き直すか。文型上「〔fix〕描きなおせばよい」に
//               続くので**連用修飾の語句**で書く（例「楕円のように横長に」。動詞止めにしない）
//   gaze_fix  = ④視点変更演習での直し方＝元の視点をどちらへ動かすと見え方が一致するか。方向は
//               MatchGazeButton.js の matchGazeDirections と一致させる（下／右）。文型上「視点を
//               〔fix〕と」に続くので「下に下げる」「右に動かす」の語形で書く。
//               **gaze_fix を持つモデルだけが視点変更演習の対象**（model1・model4・cube_model3・cube_model5）
// ▲
//
// ▼選択肢の作り方（3択）▼
// 数は3択を維持する（2026-07-27決定「自由度を広げない」）。紛らわしさの作り方だけを目的に合わせた：
//   angle     … 正解＋別方向の視点2つ（「いつもの正面」は入れない）
//   state     … 正解＋**同じモチーフ群の他モデルのおかしさ**2つ
//   knowledge … 正解＋**他モデルの既存知識**2つ（同じモチーフ群から借りる）
//   drawn     … 正解＋**同じモデルの正しい描き方**（＝対になる語）＋他モデルのdrawn
//   fix       … 正解＋**対になる誤答＝誤って描いた方向／逆向きの視点移動**＋他モデルのfix
// **`drawn` と `fix` の両方に「対になる誤答」を必ず1つ入れる**のが測定の要（2026-10-03に fix へ追加）：
// 既存知識から導かれる形（正円）と正しい描き方（楕円）を区別できない学習者は、どちらかで対の誤答を
// 選ぶ。他モデルの語だけを誤答にすると部位違いで消去法が効いてしまい、区別を測れない。
// ▲
//
// correct は候補データのQA用メモであり、正誤判定には使わない（選択自体がログの対象）。
// 正解の位置は固定しない。

export const SELF_EXP_OPTIONS = {
  // グラス丸皿#1：皿を丸く描きすぎる（既存知識「皿は丸い」）
  // 顕在化＝横から見ると皿が空中で傾斜した、物理的にあり得ない配置になる
  model1: {
    angle: { options: ['真上から', '真下から', '横から'], correct: '横から' },
    state: { options: ['飲み口が尖って見える', '皿が空中に傾いて浮いている', 'グラスが皿にめり込んで見える'], correct: '皿が空中に傾いて浮いている' },
    drawn: { options: ['皿を正円に近い形で描いている', '皿を楕円に描いている', 'グラスを太く描いている'], correct: '皿を正円に近い形で描いている' },
    knowledge: { options: ['皿は丸いものである', 'グラスは円柱である', '皿はグラスより大きい'], correct: '皿は丸いものである' },
    shape_fix: { options: ['正円のように丸く', '楕円のように横長に', '小さく'], correct: '楕円のように横長に' },
    gaze_fix: { options: ['上に上げる', '下に下げる', '右に動かす'], correct: '下に下げる' },
  },
  // グラス丸皿#2：皿を大きく描きすぎる（既存知識「皿はグラスより大きい」）
  // 顕在化＝真上から見るとグラスと皿が重なって見える
  model2: {
    angle: { options: ['横から', '真上から', '真下から'], correct: '真上から' },
    state: { options: ['皿がグラスにめり込んで見える', '皿が空中に傾いて浮いている', '飲み口が尖って見える'], correct: '皿がグラスにめり込んで見える' },
    drawn: { options: ['皿を大きく描いている', '皿を小さく描いている', 'グラスを太く描いている'], correct: '皿を大きく描いている' },
    knowledge: { options: ['皿はグラスより大きい', '皿は丸いものである', '皿のふちはどこも同じ幅である'], correct: '皿はグラスより大きい' },
    shape_fix: { options: ['小さく', '大きく', '楕円のように横長に'], correct: '小さく' },
  },
  // グラス丸皿#3：グラスを太く描きすぎる（既存知識「グラスは皿より大きい」）
  // 顕在化＝真上から見ると、幅だけ太くなったグラスの飲み口がつぶれて見える（2026-10-09変更）
  // state の誤答は同じ部位（飲み口）の model4 と、旧正答の「めり込み」（model5 と同文）
  model3: {
    angle: { options: ['真上から', '横から', '背面から'], correct: '真上から' },
    state: { options: ['飲み口が尖って見える', '飲み口がつぶれて見える', 'グラスが皿にめり込んで見える'], correct: '飲み口がつぶれて見える' },
    drawn: { options: ['グラスを太く描いている', 'グラスを細く描いている', '皿を大きく描いている'], correct: 'グラスを太く描いている' },
    knowledge: { options: ['グラスは皿より大きい', '皿は丸いものである', 'グラスの側面はまっすぐ平行である'], correct: 'グラスは皿より大きい' },
    shape_fix: { options: ['太く', '小さく', '細く'], correct: '細く' },
  },
  // グラス丸皿#4：飲み口を正円に描く（既存知識「グラスは円柱である」）
  // 顕在化＝横から見るとグラスの飲み口が尖って見える
  model4: {
    angle: { options: ['真上から', '真下から', '横から'], correct: '横から' },
    state: { options: ['グラスが皿にめり込んで見える', '皿が空中に傾いて浮いている', '飲み口が尖って見える'], correct: '飲み口が尖って見える' },
    // 画面上の飲み口は正円ではなく丸みが強い楕円（縦横比0.64、モチーフは0.13）なので「正円に近い形で」（2026-10-16）
    drawn: { options: ['飲み口を正円に近い形で描いている', '飲み口を楕円に描いている', '皿を正円に近い形で描いている'], correct: '飲み口を正円に近い形で描いている' },
    knowledge: { options: ['グラスは円柱である', '皿は丸いものである', 'グラスの側面はまっすぐ平行である'], correct: 'グラスは円柱である' },
    shape_fix: { options: ['正円のように丸く', '細く', '楕円のように横長に'], correct: '楕円のように横長に' },
    gaze_fix: { options: ['下に下げる', '上に上げる', '左に動かす'], correct: '下に下げる' },
  },
  // グラス丸皿#5：側面のすぼまりを描かない（既存知識「グラスの側面はまっすぐ平行である」）
  // 顕在化＝横から見るとグラスと皿が重なって見える
  model5: {
    angle: { options: ['真上から', '横から', '真下から'], correct: '真下から' },
    state: { options: ['飲み口が尖って見える', '皿のふちがグラスにめり込んで見える', 'グラスが皿にめり込んで見える'], correct: 'グラスが皿にめり込んで見える' },
    drawn: { options: ['グラスの側面をまっすぐに描いている', 'グラスの側面をすぼめて描いている', 'グラスを太く描いている'], correct: 'グラスの側面をまっすぐに描いている' },
    knowledge: { options: ['グラスの側面はまっすぐ平行である', '皿のふちはどこも同じ幅である', 'グラスは皿より大きい'], correct: 'グラスの側面はまっすぐ平行である' },
    shape_fix: { options: ['下をすぼめて', 'まっすぐ平行に', '細く'], correct: '下をすぼめて' },
  },
  // グラス丸皿#6：ふち（リム）を広く描きすぎる（既存知識「皿のふちはどこも同じ幅である」）
  // 顕在化＝横から見るとグラスと皿が重なって見える
  model6: {
    angle: { options: ['真上から', '横から', '背面から'], correct: '真上から' },
    state: { options: ['皿のふちがグラスにめり込んで見える', 'グラスが皿にめり込んで見える', 'グラスが傾いて不安定に見える'], correct: '皿のふちがグラスにめり込んで見える' },
    drawn: { options: ['ふちを広く描いている', 'ふちを狭く描いている', '皿を大きく描いている'], correct: 'ふちを広く描いている' },
    knowledge: { options: ['皿のふちはどこも同じ幅である', '皿は丸いものである', '皿には深さがある'], correct: '皿のふちはどこも同じ幅である' },
    shape_fix: { options: ['広く', '狭く', '小さく'], correct: '狭く' },
  },
  // グラス丸皿#7(=model8)：皿を深く描きすぎる（既存知識「皿には深さがある」）
  // ※実装（SpherePlate8.js）は上（ふちを高く＝従来版）と下（底を下げる）の両方向に深くする（2026-10-09変更）
  // 顕在化＝横から見ると皿の底がグラスの底（置かれた面）より下に沈みこんで見える
  // state の誤答は同じ部位（皿）の model1・model2 のおかしさ
  model8: {
    angle: { options: ['真上から', '横から', '真下から'], correct: '横から' },
    state: { options: ['皿がグラスにめり込んで見える', '皿の底がグラスの底より下に沈みこんで見える', '皿が空中に傾いて浮いている'], correct: '皿の底がグラスの底より下に沈みこんで見える' },
    drawn: { options: ['皿を深く描いている', '皿を浅く描いている', 'ふちを広く描いている'], correct: '皿を深く描いている' },
    knowledge: { options: ['皿には深さがある', '皿のふちはどこも同じ幅である', '皿は丸いものである'], correct: '皿には深さがある' },
    shape_fix: { options: ['深く', '狭く', '浅く'], correct: '浅く' },
  },
  // グラス丸皿#8(=model7)：グラスを斜めに描く
  // ※誤り一覧表では**スキーマ起因ではない**（他の箇所とのつじつま合わせ・運筆の誤差）とされる唯一の誤り。
  //   knowledge は「まわりの形に合わせて描けばよい」という思い込みを暫定的に置いている（要検討）
  // 顕在化＝横から見るとグラスが傾いて不安定に見える
  model7: {
    angle: { options: ['真上から', '横から', '背面から'], correct: '横から' },
    state: { options: ['皿が空中に傾いて浮いている', 'グラスが傾いて不安定に見える', '皿がグラスにめり込んで見える'], correct: 'グラスが傾いて不安定に見える' },
    drawn: { options: ['グラスを斜めに描いている', 'グラスをまっすぐに描いている', '皿を正円に近い形で描いている'], correct: 'グラスを斜めに描いている' },
    knowledge: { options: ['まわりの形に合わせて描けばよい', 'グラスは円柱である', '皿は丸いものである'], correct: 'まわりの形に合わせて描けばよい' },
    shape_fix: { options: ['斜めに', 'まっすぐ', '細く'], correct: 'まっすぐ' },
  },
  // ▼立方体の drawn・shape_fix は紙の上での描き方（2026-10-16に全面修正）▼
  //   いつもの視点の画面に写した数値（モチーフ→誤り）で確かめた：
  //   #1 上面の奥の辺÷手前の辺 0.78→0.94（左右の辺がほぼ平行）
  //   #2 側面の奥の縦の辺÷手前の縦の辺 0.81→1.00（同じ高さ）
  //   #3 上面の奥へ向かう辺の縦からの傾き 48°・69°→29°・52°（縦に立っている＝角が直角に近い）
  //   #4 底面の奥へ向かう辺の傾き 23°→38°（上面の辺の48°と平行に近い）
  //   #5 上面の画面上の高さ 44→152（縦に広い）
  // ▲
  // 立方体#1：幅の発散遠近（既存知識「立方体の平行な辺は見た目でも平行である」）
  // 顕在化＝真上から見ると上面が台形に見える（3Dモデルは奥ほど幅が広がる）
  // デッサン＝上面の左右の辺を平行に描いている（正しくは奥ほど狭まる）
  cube_model1: {
    angle: { options: ['横から', '真上から', '背面から'], correct: '真上から' },
    state: { options: ['上面が台形に見える', '側面が台形に見える', '側面が歪んだ四角形に見える'], correct: '上面が台形に見える' },
    drawn: { options: ['上面の左右の辺を平行に描いている', '上面の左右の辺を奥ほど狭めて描いている', '側面の奥の縦の辺を手前と同じ高さに描いている'], correct: '上面の左右の辺を平行に描いている' },
    knowledge: { options: ['立方体の平行な辺は見た目でも平行である', '立方体の辺は直角に交わる', '立方体の上面は正方形である'], correct: '立方体の平行な辺は見た目でも平行である' },
    shape_fix: { options: ['奥ほど狭めて', '平行に', '奥ほど低く'], correct: '奥ほど狭めて' },
  },
  // 立方体#2：高さの発散遠近（既存知識「立方体の面はどれも同じ大きさに見える」）
  // 顕在化＝横から見ると側面が台形に見える（3Dモデルは奥ほど背が高い）
  // デッサン＝側面の奥の縦の辺を手前と同じ高さに描いている（正しくは奥ほど低い）
  cube_model2: {
    angle: { options: ['真上から', '横から', '背面から'], correct: '横から' },
    state: { options: ['上面の奥の辺が斜めに傾いて見える', '側面が台形に見える', '上面が台形に見える'], correct: '側面が台形に見える' },
    drawn: { options: ['側面の奥の縦の辺を手前と同じ高さに描いている', '側面の奥の縦の辺を手前より低く描いている', '上面の左右の辺を平行に描いている'], correct: '側面の奥の縦の辺を手前と同じ高さに描いている' },
    knowledge: { options: ['立方体の面はどれも同じ大きさに見える', '立方体の平行な辺は見た目でも平行である', '立方体の辺は直角に交わる'], correct: '立方体の面はどれも同じ大きさに見える' },
    shape_fix: { options: ['奥ほど低く', '同じ高さで', '奥ほど狭めて'], correct: '奥ほど低く' },
  },
  // 立方体#3：上面の奥へ向かう辺の角度誤り（既存知識「立方体の辺は直角に交わる」）
  // 顕在化＝真上から見ると上面の奥の辺が斜めに傾いて見える（2026-10-16変更。旧「平行四辺形に見える」は
  //   実装の形と違う＝奥の左の角は外へ、奥の右の角は手前へずれたゆがんだ四角形になる。形は変えない）
  // デッサン＝上面の奥へ向かう辺を縦に立てて描いている（手前の辺との角が直角に近い。正しくはもっと斜めに寝る）
  cube_model3: {
    angle: { options: ['横から', '真上から', '真下から'], correct: '真上から' },
    state: { options: ['上面が台形に見える', '上面の奥の辺が斜めに傾いて見える', '側面が歪んだ四角形に見える'], correct: '上面の奥の辺が斜めに傾いて見える' },
    drawn: { options: ['上面の奥へ向かう辺を縦に立てて描いている', '上面の奥へ向かう辺を斜めに寝かせて描いている', '上面の左右の辺を平行に描いている'], correct: '上面の奥へ向かう辺を縦に立てて描いている' },
    knowledge: { options: ['立方体の辺は直角に交わる', '立方体の上面は正方形である', '立方体の平行な辺は見た目でも平行である'], correct: '立方体の辺は直角に交わる' },
    shape_fix: { options: ['斜めに寝かせて', '縦に立てて', '奥ほど狭めて'], correct: '斜めに寝かせて' },
    gaze_fix: { options: ['左に動かす', '右に動かす', '下に下げる'], correct: '右に動かす' },
  },
  // 立方体#4：底面の辺の水平回転（既存知識「立方体の平行な辺は見た目でも平行である」）
  // 顕在化＝背面から見ると底面が平行四辺形に見える
  // デッサン＝底面の奥へ向かう辺を上面の辺と平行に描いている（正しくは上面の辺より立って見える）
  cube_model4: {
    angle: { options: ['真上から', '背面から', '横から'], correct: '背面から' },
    state: { options: ['上面が台形に見える', '底面が平行四辺形に見える', '側面が台形に見える'], correct: '底面が平行四辺形に見える' },
    drawn: { options: ['底面の奥へ向かう辺を上面の辺と平行に描いている', '底面の奥へ向かう辺を上面の辺より立てて描いている', '上面の奥へ向かう辺を縦に立てて描いている'], correct: '底面の奥へ向かう辺を上面の辺と平行に描いている' },
    knowledge: { options: ['立方体の平行な辺は見た目でも平行である', '立方体の辺は直角に交わる', '立方体の面はどれも同じ大きさに見える'], correct: '立方体の平行な辺は見た目でも平行である' },
    shape_fix: { options: ['上面の辺より立てて', '上面の辺と平行に', '奥ほど狭めて'], correct: '上面の辺より立てて' },
  },
  // 立方体#5：上面を開いて描く（既存知識「立方体の上面は正方形である」＝Thoulessの現象的回帰）
  // 顕在化＝横から見ると側面が歪んだ四角形に見える（2026-10-19変更。旧「上面が手前に開いて浮いて見える」は、横からでは上面が細い帯にしか見えず、「手前」の向きも分かりにくかったため。上面の頂点だけを底の辺のまわりに回しているので、横から見た側面は上の辺だけが傾いた四角形になる）
  // デッサン＝上面を縦に広く描いている（正しくは縦に狭い。旧「開いて／閉じて」は3Dのふたのたとえだったので言い換え）
  // 直し方＝「上面を縦に狭く」（2026-10-19変更。旧「薄く」は何をどの向きに直すのか分からなかったため、描き方「縦に広く」の対にして部位も入れた）
  cube_model5: {
    angle: { options: ['真上から', '横から', '背面から'], correct: '横から' },
    state: { options: ['上面が台形に見える', '側面が歪んだ四角形に見える', '底面が平行四辺形に見える'], correct: '側面が歪んだ四角形に見える' },
    drawn: { options: ['上面を縦に広く描いている', '上面を縦に狭く描いている', '上面の左右の辺を平行に描いている'], correct: '上面を縦に広く描いている' },
    knowledge: { options: ['立方体の上面は正方形である', '立方体の辺は直角に交わる', '立方体の面はどれも同じ大きさに見える'], correct: '立方体の上面は正方形である' },
    shape_fix: { options: ['上面を縦に広く', '上面を縦に狭く', '上面の左右の辺を奥ほど狭めて'], correct: '上面を縦に狭く' },
    gaze_fix: { options: ['下に下げる', '上に上げる', '左に動かす'], correct: '下に下げる' },
  },
};

// phase に応じて fix を shape_fix / gaze_fix から解決したビューを返す。
// SelfExpSelect 側は angle/state/drawn/knowledge/fix でアクセスできる。
// shape-changeは全13モデル対応、gaze-controlは gaze_fix を持つ4モデルのみ対応（他はnull）。
// どの空欄にも最後に出す「わからない」（2026-10-12追加）。適切な語が分からないときに当て推量で選ばせず、
// たまたま正答と一致する回答を区別するため。下の3択データには含めず、表示側（SelfExpSelect）で全空欄に足す
// （正答・誤答の作り方の規約はあくまで3択に対するもの）。選ぶと空欄は埋まった扱いになり、この文字列のまま記録される
export const UNKNOWN_OPTION = '△わからない';

export function getSelfExpOptions(phase, errorGlbPath) {
  const m = SELF_EXP_OPTIONS[errorGlbPath];
  if (!m) return null;
  const shared = { angle: m.angle, state: m.state, drawn: m.drawn, knowledge: m.knowledge };
  if (phase === 'shape-change') {
    return { ...shared, fix: m.shape_fix };
  }
  if (phase === 'gaze-control') {
    if (!m.gaze_fix) return null;
    return { ...shared, fix: m.gaze_fix };
  }
  return null;
}
